/**
 * TanStack Query hooks for `creative-size-limit`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	checkLimit,
	creativeSizeLimitQueryKeys,
	getEffective,
	resetLimit,
	updateLimit,
	type CheckLimitBody,
	type CheckLimitResponse,
	type EffectiveLimitView,
	type ResetLimitView,
	type UpdateLimitBody,
	type UpdatedLimitView,
} from "./api";

export function useCreativeSizeLimitEffective(): UseQueryResult<
	EffectiveLimitView,
	Error
> {
	return useQuery({
		queryKey: creativeSizeLimitQueryKeys.effective(),
		queryFn: getEffective,
	});
}

export function useCreativeSizeLimitUpdate(): UseMutationResult<
	UpdatedLimitView,
	Error,
	UpdateLimitBody
> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: updateLimit,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: creativeSizeLimitQueryKeys.all });
		},
	});
}

export function useCreativeSizeLimitReset(): UseMutationResult<
	ResetLimitView,
	Error,
	void
> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: resetLimit,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: creativeSizeLimitQueryKeys.all });
		},
	});
}

export function useCreativeSizeLimitCheck(): UseMutationResult<
	CheckLimitResponse,
	Error,
	CheckLimitBody
> {
	return useMutation({
		mutationFn: checkLimit,
	});
}
